import { render } from "./DefaultCard.vue?vue&type=template&id=153035ee&scoped=true"
import script from "./DefaultCard.vue?vue&type=script&lang=js"
export * from "./DefaultCard.vue?vue&type=script&lang=js"

import "./DefaultCard.vue?vue&type=style&index=0&id=153035ee&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-153035ee"]])

export default __exports__